import { render, staticRenderFns } from "./SmtpRelayGroup.vue?vue&type=template&id=09bd8354&scoped=true"
import script from "./SmtpRelayGroup.vue?vue&type=script&lang=js"
export * from "./SmtpRelayGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd8354",
  null
  
)

export default component.exports